var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-new-process-discover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-page-6",
    transform: "translate(-380.000000, -2298.000000)",
    fill: "#6056DE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.998964,2298 C390.765951,2298 380,2308.76655 380,2321.99974 C380,2335.23303 390.7663,2346 403.998964,2346 C417.232758,2346 428,2335.23319 428,2322 C428,2308.76664 417.232848,2298 403.998964,2298 Z M403.998964,2342.82594 C392.515622,2342.82594 383.173833,2333.48352 383.173833,2321.99948 C383.173833,2310.51584 392.515485,2301.1738 403.998964,2301.1738 C415.483419,2301.1738 424.826167,2310.51604 424.826167,2322 C424.826167,2333.48357 415.483289,2342.82594 403.998964,2342.82594 Z M403.999223,2311.16753 C398.027052,2311.16803 393.167411,2316.02785 393.167411,2321.99974 C393.167411,2327.97262 398.027002,2332.83247 403.999482,2332.83247 C409.972196,2332.83247 414.832071,2327.97265 414.832071,2322 C414.832071,2316.02714 409.972248,2311.16753 403.999223,2311.16753 Z M403.999482,2329.65867 C399.776412,2329.65867 396.341244,2326.22321 396.341244,2321.99974 C396.341244,2317.77697 399.776487,2314.3416 403.999482,2314.34133 C408.222944,2314.34133 411.658238,2317.77667 411.658238,2322 C411.658238,2326.22325 408.222773,2329.65867 403.999482,2329.65867 Z M403.999741,2325.84722 C406.124523,2325.84722 407.846998,2324.12476 407.846998,2322 C407.846998,2319.87524 406.124523,2318.15278 403.999741,2318.15278 C401.87496,2318.15278 400.152484,2319.87524 400.152484,2322 C400.152484,2324.12476 401.87496,2325.84722 403.999741,2325.84722 Z",
    id: "ic-new-process-discover"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.37c6c44ff5438e7fb63f1677053593db.svg";
export { ForwardRef as ReactComponent };